<page-header class="page-header"  [showCheckbox]="false" [selctedButton]="router.url" (showBlockedChanged)="loadVideos()"></page-header>
<!-- [ngStyle]="{'height': header === 'history' ? '70px' : '105px'}" -->
<button *ngIf="header =='הסטוריה'" id="delete-history" (click)="clearHistory()">
    מחק הסטוריה
</button>
<h1>{{header}}</h1>
<videos [videos]="videos" (removedFromFavorites)="removeVideo($event)" class="videos"></videos>

<h2 *ngIf="dataLoaded&&!videos.length">לא נמצאו נתונים</h2>

<div class="loading-div" *ngIf="!dataLoaded">
    <div class="d-flex justify-content-center">
        <div class="spinner-border large-spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <span>אנחנו טוענים עבורך את הסרטונים...</span>
</div>